export const inOutStatus = [
  {
    label: "IN",
    color: "green",
    value: 0,
  },
  {
    label: "OUT",
    color: "red",
    value: 1,
  },
  {
    label: "RETURN",
    color: "blue",
    value: 2,
  },
  {
    label: "SCRAP",
    color: "grey",
    value: 3,
  },
];

export const sentRecdStatus = [
  {
    label: "SENT",
    color: "green",
    value: 0,
  },
  {
    label: "RECD",
    color: "red",
    value: 1,
  },
];

export const progressValues = [
  {
    label: "In-Process",
    value: 0,
  },
  {
    label: "Completed",
    value: 1,
  },
];

export const partyTypeValues = [
  {
    label: "Client",
    value: "client",
  },
  {
    label: "Vendor",
    value: "vendor",
  },
];

export const companyTypeValues = [
  {
    label: "Pressco-Fab",
    value: "PF",
    color: "blue",
  },
  {
    label: "Press-Tech",
    value: "PT",
    color: "orange",
  },
];
